// The hiring roleplay rebuild (DA-5042): a roleplay is three sections, and each
// level above Weak is graded by one fact or event in it. The same composition
// as the backend's (shared/services/hiring/markers.ts there), so a roleplay the
// owner edits in three fields compares equal to what Elliott drafted.

import type { HiringSections } from '../../../../api/hiring';

export const SECTION_FIELDS: Array<{ key: keyof HiringSections; heading: string; hint: string }> = [
  { key: 'whatYouKnow', heading: 'What you know', hint: 'The facts, one for each level above Weak. Nothing else.' },
  { key: 'whatsHappened', heading: "What's happened", hint: 'The events, then the request from one person.' },
  { key: 'yourTask', heading: 'Your task', hint: 'The same ask as the request, in the same words.' }
];

/** The three sections as one text under their headings (the backend's composeRoleplay). */
export const composeSections = (s: HiringSections): string =>
  SECTION_FIELDS.map((f) => `${f.heading}\n${String(s[f.key] || '').trim()}`).join('\n\n');

/** The three sections back from one text, or null when its headings aren't all there. */
export function parseSections(text: string): HiringSections | null {
  const out: Partial<HiringSections> = {};
  for (const block of String(text || '').replace(/\r/g, '').split(/\n\s*\n/)) {
    const [first, ...rest] = block.trim().split('\n');
    const field = SECTION_FIELDS.find((f) => f.heading.toLowerCase() === String(first || '').trim().toLowerCase());
    if (!field) return null;
    out[field.key] = rest.join(' ').replace(/\s+/g, ' ').trim();
  }
  return out.whatYouKnow && out.whatsHappened && out.yourTask ? (out as HiringSections) : null;
}

export const ASSUMED_NOTE = 'Elliott assumed this. Check it before opening the round.';

/**
 * A level's label from the backend, in two parts for a table cell: the star a
 * provisional level carries, and the words under it ("Advanced in roleplay,
 * quiz incorrect", "changed by the hiring manager"). Both empty for a plain level.
 */
export function labelParts(label?: string): { star: string; note: string } {
  const text = String(label || '');
  const head = text.split(' · ')[0];
  const star = /\*/.test(head) ? '*' : '';
  const note = text.includes(' · ') ? text.split(' · ').slice(1).join(' · ') : /\(changed by the hiring manager\)/.test(text) ? 'changed by the hiring manager' : '';
  return { star, note };
}
